import * as API from "middleware/api";

export const afipFormsList = (data) => API.executeWithAccessToken("/rapipago.afip.forms", { data });
export const afipFormFields = (codForm) => API.executeWithAccessToken(`rapipago.afip.form.fields`, { codForm });
export const afipFormFieldCode = (data) => API.executeWithAccessToken(`/rapipago.afip.form.combobox`, { ...data });
export const afipTaxForms = (data) => API.executeWithAccessToken(`/rapipago.afip.form.taxes`, { ...data });
export const afipBarCodeGenerator = (data) => API.executeWithAccessToken(`/rapipago.afip.form.barcode`, { ...data });
export const afipPreparePayment = (data) => API.executeWithAccessToken(`/rapipago.afip.prepare`, { ...data });
export const afipConfirmPayment = (data) => API.executeWithAccessToken(`/rapipago.operation.confirm`, { ...data });
